import React from "react";

const TiccaLogoTextWhite = () => {
  return (
    <img src="https://public.ticca.com/images/svg/TiccaLogo_Null_EmailVerification_WhiteRedOrangeGreen_150X33.svg" alt=" "/>
  );
};

export default TiccaLogoTextWhite;
